import Pet from "./Pet";

export default class PetRaven extends Pet {
    constructor() {
        super("guardian_pet", Pet.TYPE_RAVEN);
    }

    init() {
        super.init(P3.utils.selectRandom(["pet4"]));
    }
}